module.exports = __webpack_public_path__ + "img/logo.d7c2a551.png";